import { jsx as r } from "react/jsx-runtime";
import { QueryClient as t } from "../node_modules/@tanstack/query-core/build/modern/queryClient.mjs";
import { QueryClientProvider as n } from "../node_modules/@tanstack/react-query/build/modern/QueryClientProvider.mjs";
const o = new t({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function u({ children: e }) {
  return /* @__PURE__ */ r(n, { client: o, children: e });
}
export {
  u as QueryClientProvider
};
